import api, { BACKEND_URL } from './client';
import type { AxiosResponse } from 'axios';

export const getMessages = (matchId: string): Promise<AxiosResponse> => api.get(`/messages/${matchId}`);
export const sendMessage = (matchId: string, text: string): Promise<AxiosResponse> => api.post(`/messages/${matchId}`, { text });
export const markMessagesRead = (matchId: string): Promise<AxiosResponse> => api.post(`/messages/${matchId}/read`);
export const markMessagesDelivered = (matchId: string): Promise<AxiosResponse> => api.post(`/messages/${matchId}/delivered`);

// WebSocket (auth via initial message, not URL)
export const getWsUrl = (matchId: string): string => {
  const wsBase = BACKEND_URL.replace('https://', 'wss://').replace('http://', 'ws://');
  return `${wsBase}/api/ws/chat/${matchId}`;
};
export const getWsAuthToken = (): string | null => localStorage.getItem('dutchdate_token');

// Chat enhancements
export const searchGifs = (q: string): Promise<AxiosResponse> => api.get(`/chat/gifs?q=${encodeURIComponent(q)}`);
export const reactToMessage = (messageId: string, reaction: string): Promise<AxiosResponse> => api.post(`/messages/${messageId}/react?reaction=${reaction}`);
export const getMessageReactions = (messageId: string): Promise<AxiosResponse> => api.get(`/messages/${messageId}/reactions`);
export const getOpeningMoves = (): Promise<AxiosResponse> => api.get('/chat/opening-moves');
export const getMoneyTalkStarters = (): Promise<AxiosResponse> => api.get('/chat/money-talk-starters');
export const submitGameAnswer = (gameId: string, matchId: string, qIndex: number, answer: string): Promise<AxiosResponse> =>
  api.post(`/chat/money-talk-starters/${gameId}/answer?match_id=${matchId}&question_index=${qIndex}&answer=${encodeURIComponent(answer)}`);

// Video Chat
export const getVideoToken = (matchId: string): Promise<AxiosResponse> => api.post('/video/token', { match_id: matchId });
